import { ISuiteTypes } from '@llws/lift-entity-interfaces';

interface IChangesSummaryState {
  subjectsToUpdate: ISuiteTypes[],
  removedSubjects: ISuiteTypes[],
}

const initState: IChangesSummaryState = {
  subjectsToUpdate: [],
  removedSubjects: [],
};

export default {
  namespaced: true, // 'changes-summary/'
  state: initState,
  getters: {
    subjectsToUpdate: (state: IChangesSummaryState) => [ ...state.subjectsToUpdate ],
    removedSubjects: (state: IChangesSummaryState) => state.removedSubjects.map((subject) => subject.id),
  },
  mutations: {
    setSubjectsToUpdate: (state: IChangesSummaryState, payload: ISuiteTypes[]) => {
      state.subjectsToUpdate = payload;
    },
    initialize: (state: IChangesSummaryState) => {
      state.subjectsToUpdate = [];
      state.removedSubjects = [];
    },
    removeSubjects: (state: IChangesSummaryState, payload: ISuiteTypes[]) => {
      state.removedSubjects = [
        ...state.removedSubjects,
        ...payload,
      ];
    },
    revertRemovedSubjects: (state: IChangesSummaryState, payload: ISuiteTypes[]) => {
      state.removedSubjects = state.removedSubjects.filter((subject) => !payload.some((item) => item.id === subject.id));
    },
  },
  actions: {
  },
};
